const createError = (code: number, message: string) => ({ code, message });

export default createError;
